import { UserId } from '@/portainer/users/types';
import { ScopedKubeconfigsDatatable } from '@/react/portainer/scoped-kubeconfigs/components/ScopedKubeconfigsDatatable';
import { useAllScopedKubeconfigs } from '@/react/portainer/scoped-kubeconfigs/queries/useAllScopedKubeconfigs';
import { useEnvironmentNames } from '@/react/portainer/scoped-kubeconfigs/queries/useEnvironmentNames';

export function KubeconfigsTab({ userId }: { userId: UserId }) {
  const scopedKubeconfigsQuery = useAllScopedKubeconfigs({
    select: (scopedKubeconfigs) =>
      scopedKubeconfigs.filter(
        (scopedKubeconfig) => scopedKubeconfig.userId === userId
      ),
  });
  const environmentNames = useEnvironmentNames();

  return (
    <ScopedKubeconfigsDatatable
      dataset={scopedKubeconfigsQuery.data ?? []}
      isLoading={scopedKubeconfigsQuery.isLoading}
      tableKey="user-scoped-kubeconfigs"
      showOwner={false}
      showEnvironment
      environmentNames={environmentNames}
      description="Read-only kubeconfigs this user holds, across every Kubernetes environment. Revoking one stops any kubectl session using it immediately."
    />
  );
}
